module.exports = angular.module('cartographer.map.inspectormap', [])

_ = require 'underscore'

module.exports.provider 'crtInspectorMapQueryParams', ->
  # Configuration for Angular UI Router:
  this.stateParamSpec = [
    '/:layer'
    '?attribute'
    '?center'
    '?zoom'
    '?from'
    '?to'
    '?crossws'
    '?tiles'
    '?fixed'
    '?scrollwheel'
    '?selectradius'
    '?inspector'
    '?feature'
    '?module'
    '?survey'
  ].join('')

  this.$get = $DI (
    crtLog
    crtConfig
    crtString
    crtDatetime
    crtLocation
    crtMapInspectorState
  ) ->
    parse = (params, options = { workspace: null, credentials: null }) ->
      # crtLog.debug('crtInspectorMapQueryParams.parse', params, options)
      ans = {}
      ans.subdomain       = params.subdomain
      if (params.layer ? "").indexOf(".") < 0
        # New-style URLs: layer and attribute specified separately:
        ans.layer           = params.layer
        ans.attribute       = params.attribute
      else
        # Old-style URLs: layer and attribute specified in layer as "foo.bar":
        ans.layer           = params.layer.split(".")[0]
        ans.attribute       = params.attribute ? params.layer.split(".")[1]
      ans.location        = if params.center
                              crtLocation.parseLatLng(params.center)
                            else if options.workspace?.mapCenter
                              options.workspace.mapCenter
                            else
                              crtLocation.london()
      ans.zoom            = crtString.intAttr(
                              params.zoom
                              if options.workspace?.mapZoom
                                options.workspace.mapZoom
                              else
                                crtConfig.map.defaultZoom
                            )
      ans.from            = if params.from then crtDatetime.parse(params.from) else undefined
      ans.to              = if params.to   then crtDatetime.parse(params.to)   else undefined
      ans.crossws         = crtString.booleanAttr(params.crossws, null)
      ans.mapTiles        = params.tiles ? crtConfig.map.defaultTiles
      ans.fixed           = crtString.booleanAttr(params.fixed, false)
      ans.scrollWheel     = crtString.booleanAttr(params.scrollwheel, options.scrollwheelDefault ? true)
      ans.selectionRadius = crtString.intAttr(params.selectradius, null) # m
      ans.inspectorState  = crtMapInspectorState.create(params.inspector?.toLowerCase() ? 'yes', options)
      ans.feature         = crtString.intAttr(params.feature, null)
      ans.module          = params.module
      ans.survey          = params.survey
      [ ans.enableLegend, ans.showLegend ] =
        switch (params.legend?.toLowerCase() ? 'yes') # or('show', 'hide', 'no', null)
          when 'no', 'false' then [ false, false ]
          when 'hide'        then [  true, false ]
          else                    [  true,  true ]
      # crtLog.debug('crtMapInspectorQueryParams.parse', params, ans)
      return ans

    # crtInspectorMap -> object(string, string)
    format = (crtInspectorMap) ->
      # crtLog.debug('crtInspectorMapQueryParams.format', crtInspectorMap)
      return {
        layer        : crtInspectorMap.featureLayer.id
        attribute    : crtInspectorMap.attributeLayer?.id ? undefined
        center       : crtLocation.formatQueryParameter(crtInspectorMap.location)
        zoom         : crtInspectorMap.zoom
        from         : if crtInspectorMap.from? then crtDatetime.format(crtInspectorMap.from , 'YYYY-MM-DD') else undefined
        to           : if crtInspectorMap.to?   then crtDatetime.format(crtInspectorMap.to   , 'YYYY-MM-DD') else undefined
        crossws      : crtInspectorMap.crossws
        tiles        : crtInspectorMap.mapTiles
        fixed        : crtInspectorMap.fixed
        scrollwheel  : crtInspectorMap.scrollWheel
        selectradius : crtInspectorMap.selection?.radius()
        inspector    : crtInspectorMap.inspectorState.queryParameter()
        legend       : if crtInspectorMap.showLegend
                         'show'
                       else if crtInspectorMap.enableLegend
                         'hide'
                       else
                         'no'
        feature      : crtInspectorMap.selection?.direct()?.id
        module       : null
        survey       : null
      }

    return {
      parse
      format
    }

  return

module.exports.directive 'crtInspectorMap', $DI (
  crtLog
  $timeout
  crtConfig
  crtHttp
  crtString
  crtDatetime
  crtLocation
  crtFeature
  crtLayer
  crtFeatureLayer
  crtAttributeLayer
  crtAttributeBucket
  crtFeatureMapSelection
  crtMapInspectorState
  crtInspectorMapQueryParams
) ->
  return {
    restrict: 'A'
    template: require './inspector-map.tpl.html'
    scope:
      subdomain              : '=' # string
      layer                  : '=' # string
      attribute              : '=?' # or(string, null)
      location               : '=' # location
      zoom                   : '=' # [1,20]
      from                   : '=' # or(date, null)
      to                     : '=' # or(date, null)
      crossws                : '=' # or(boolean, null)
      mapTiles               : '=' # or('terrain', 'satellite')
      fixed                  : '=' # boolean
      scrollWheel            : '=' # boolean
      selectionRadius        : '=' # or(number, null) # meters
      initialDirectSelection : '=' # or(searchresults<feature>, null)
      inspectorState         : '=' # crtInspectorState
      enableLegend           : '=' # boolean
      showLegend             : '=' # boolean
      updateUrl              : '=?' # (... -> void)
      widget                 : '=?'
    controllerAs: 'crtInspectorMap'
    bindToController: true
    controller: $DI ($scope) ->
      crtInspectorMap = this

      # or(crtAttributeLayer, null) -> arrayOf(crtAttributeBucket)
      _attributeBuckets = (attrLayer, features = []) ->
        attrLayer?.buckets(features) ? crtAttributeBucket.defaultBuckets()

      # Layers ----------------------------------

      crtInspectorMap.featureLayer   = crtLayer.featureLayer(crtInspectorMap.layer)
      crtInspectorMap.attributeLayer = crtLayer.attributeLayer(crtInspectorMap.layer, crtInspectorMap.attribute)

      crtLog.debug('crtInspectorMap.controller', crtInspectorMap.crossws, crtInspectorMap.featureLayer?.crossWorkspace)

      # Centre and zoom -------------------------

      crtInspectorMap.selectionRadius ?= crtInspectorMap.featureLayer.selectionRadius ? crtConfig.map.defaultSelectionRadius
      crtInspectorMap.location        ?= crtLocation.london()
      crtInspectorMap.zoom            ?= crtConfig.map.defaultZoom

      # Query parameters ------------------------

      crtInspectorMap.from           = undefined
      crtInspectorMap.to             = undefined
      crtInspectorMap.crossws       ?= crtInspectorMap.featureLayer.crossWorkspace ? false
      crtInspectorMap.ne             = undefined
      crtInspectorMap.sw             = undefined

      # Features and selected features ----------

      crtInspectorMap.features       = crtInspectorMap.initialDirectSelection?.results ? []
      crtInspectorMap.selection      = crtFeatureMapSelection.create(
                                         -> crtInspectorMap.features
                                         if crtInspectorMap.initialDirectSelection?.results?.length > 0 then crtInspectorMap.initialDirectSelection.results[0] else null
                                         crtInspectorMap.selectionRadius
                                       )
      crtInspectorMap.buckets        = _attributeBuckets(crtInspectorMap.attributeLayer, crtInspectorMap.features)

      # Enable/disable widgets ------------------

      crtInspectorMap.mapTiles       ?= crtConfig.map.defaultTiles
      crtInspectorMap.inspectorState ?= crtMapInspectorState.create('yes')
      crtInspectorMap.enableLegend   ?= true
      crtInspectorMap.showLegend     ?= false
      crtInspectorMap.fixed          ?= false
      crtInspectorMap.scrollWheel    ?= true

      # Querying the API ------------------------

      queryParams = ->
        workspace : if crtInspectorMap.crossws then null else crtInspectorMap.subdomain
        ne        : crtInspectorMap.ne
        sw        : crtInspectorMap.sw
        from      : if crtInspectorMap.featureLayer.hasTimestamp then crtInspectorMap.from else null
        to        : if crtInspectorMap.featureLayer.hasTimestamp then crtInspectorMap.to   else null
        simplify  : true

      findFeatures = ->
        params = queryParams()
        # crtLog.debug('crtInspectorMap.findFeatures', params)
        if params.ne && params.sw
          crtFeature.search(crtInspectorMap.featureLayer.id, params).then (response) ->
            crtInspectorMap.attribution = response.attribution
            crtInspectorMap.features    = response.results
            # updateLayer()
            return
        return

      crtInspectorMap.downloadLink = (format = 'geojson') ->
        baseParams = _.extend({}, queryParams(), { format, authorization: crtHttp.accessToken() })
        # crtLog.debug('crtInspectorMap.downloadLink', format, baseParams)
        crtFeature.searchUrl(crtInspectorMap.featureLayer, baseParams)

      layerUpdated = ->
        crtInspectorMap.buckets = _attributeBuckets(crtInspectorMap.attributeLayer, crtInspectorMap.features)
        # crtLog.debug('crtInspectorMap.layerUpdated', crtInspectorMap.featureLayer, crtInspectorMap.attributeLayer, crtInspectorMap.buckets)
        return

      $scope.$watch('crtInspectorMap.attributeLayer.id',  layerUpdated)
      $scope.$watch('crtInspectorMap.inspectorState',     layerUpdated, true)
      $scope.$watchCollection('crtInspectorMap.features', layerUpdated)

      $scope.$watch(queryParams, findFeatures, true)

      # When the map bounds change --------------

      crtInspectorMap.onBoundsChange = (ne, sw) ->
        # crtLog.debug('crtInspectorMap.onBoundsChange', ne, sw)
        crtInspectorMap.ne = ne
        crtInspectorMap.sw = sw
        return

      # URL changes -----------------------------

      # object(string, string)
      crtInspectorMap.urlParams = {}

      # -> object(string, string)
      crtInspectorMap.calcUrlParams = ->
        crtInspectorMapQueryParams.format(crtInspectorMap)

      # object(string, string) -> void
      crtInspectorMap.urlParamsUpdated = (params) ->
        crtInspectorMap.urlParams = params
        crtInspectorMap.updateUrl?(params)
        return

      $scope.$watch(crtInspectorMap.calcUrlParams, crtInspectorMap.urlParamsUpdated, true)

      return
  }
